import { render, staticRenderFns } from "./RestrictedKeywords.vue?vue&type=template&id=064f4fe4"
import script from "./RestrictedKeywords.vue?vue&type=script&lang=js"
export * from "./RestrictedKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports